<template>
	<div class="main architecture">
		<div class="model">
			<vue-virtual-item size="big" :key="'vvi'+index" v-for="(item,index) in list" :title="item.title"
				:img="item.img" :label1="item.label1" :label2="item.label2" :url="item.id"
				:margin_right_0="(index+1)%5==0"></vue-virtual-item>
		</div>
		<router-link to="/home/product2" class="" style="text-decoration: none;color: #0166FF;"><button
				class="index-btn">更&nbsp;多&nbsp;产&nbsp;品</button></router-link>
	</div>
</template>

<script>
	import vueVirtualItem from './vue-virtual-item.vue'
	import config from '../util/config.js'
	export default {
		components: {
			vueVirtualItem
		},
		data() {
			return {
				list: [{
						id: '/home/product2/zyjnds2',
						title: '中药技能大赛仿真实训平台',
						img: config.old_file_path + '/Files/img/3.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: config.old_file_path + '/Files/ProductContent/1.html'
					}, {
						id: '/home/product2/details/a94235b4-955c-11ec-abc1-00163e0400dc',
						title: '老年照护',
						img: 'https://yigee-source.oss-cn-beijing.aliyuncs.com/webofficial/16456984687182042.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: ''
					}, {
						id: '/home/product2/details/97473E03-563D-4AAD-87DE-DFF0C96F0121',
						title: '药房管理虚拟实训系统  ',
						img: config.old_file_path + '/Files/img/1.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: config.old_file_path + '/Files/ProductContent/1.html'
					},
					{
						id: '/home/product2/details/7CCB09A8-9A8B-4C27-8D02-71F4966A9A50',
						title: '中药炮制虚拟仿真教学系统',
						img: 'https://yigee-source.oss-cn-beijing.aliyuncs.com/webofficial/%E4%B8%AD%E8%8D%AF%E7%82%AE%E5%88%B6%E8%99%9A%E6%8B%9F%E4%BB%BF%E7%9C%9F%E6%95%99%E5%AD%A6%E7%B3%BB%E7%BB%9F/1.jpg',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: ''
					},
					{
						id: '/home/product2/details/5387544C-47A0-48EA-A364-E3B0CA67EF38',
						title: '中药鉴别实训仿真软件',
						img: config.old_file_path + '/Files/img/5.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: config.old_file_path + '/Files/ProductContent/5.html'
					}, {
						id: '/home/product2/myszjspt',
						title: '墨影数字教师平台',
						img: 'https://yigee-source.oss-cn-beijing.aliyuncs.com/webofficial/ai/home.png',
						label1: '易格',
						label2: '北京易格通智仿真',
						url: ''
					}
				]
			}
		}
	}
</script>

<style scoped>
	.main {
		width: 1280px;
		margin: 0 auto;
		text-align: center;
	}

	.main .index-btn {
		width: 177px;
		height: 46px;
		background: rgba(1, 213, 119, 0);
		border: 1px solid #007985;
		font-size: 16px;
		font-weight: 700;
		color: #007985;
		line-height: 22px;
		cursor: pointer;
	}

	.main .model {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.main .model .big {
		margin: auto;
	}
</style>